import { IActionTypeBase } from '../IActionTypeBase';
import { ISubSystemItemViewModel } from './../../../model/respone/user/ISubSystem';
export enum eSubSystemActionTypeIds {
    LOAD_START = "SUB_SYTEM_LOAD_START",
    LOAD_SUCCESS = "SUB_SYTEM_LOAD_SUCCESS",
    LOAD_ERROR = "SUB_SYTEM_LOAD_ERROR",
}
export interface ISubSystemLoadStart extends IActionTypeBase<eSubSystemActionTypeIds.LOAD_START, undefined> { }
export interface ISubSystemLoadSuccess extends IActionTypeBase<eSubSystemActionTypeIds.LOAD_SUCCESS, ISubSystemItemViewModel[]> { }
export interface ISubSystemLoadError extends IActionTypeBase<eSubSystemActionTypeIds.LOAD_ERROR, string> { }

export type ISubSystemActionTypes = ISubSystemLoadStart | ISubSystemLoadSuccess | ISubSystemLoadError